<template>
  <div>
    <custom-actions>
      <template #header>
      </template>
      <el-form inline ref="searchForm" class="global-form-label-width">
        <el-form-item prop="vehicleDate" label="进场日期">
          <el-date-picker v-model="searchForm.vehicleDate" type="date" placeholder="进场日期" format="yyyy-MM-dd"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click='onSearch'>查询</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card class="mt10" shadow="never">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column show-overflow-tooltip label="司机姓名" prop="driverName"></el-table-column>
        <el-table-column show-overflow-tooltip label="司机手机号" prop="driverMobile"></el-table-column>
        <el-table-column show-overflow-tooltip label="车牌号" prop="vehicleKey"></el-table-column>
        <el-table-column show-overflow-tooltip label="进厂日期" prop="vehicleDate"></el-table-column>
        <el-table-column show-overflow-tooltip label="进厂时间" prop="vehicleTime">
          <template v-slot="{ row }">
            {{ vehicleTimeTypeMap.get(row.vehicleTime) || '--' }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="是否散油" prop="inventoryType">
          <template v-slot="{ row }">
            <el-tag v-if="row.isBulkOil === 1" type="success">是</el-tag>
            <el-tag v-else type="danger">否</el-tag>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="状态" prop="nodeName"></el-table-column>
        <el-table-column label="操作" width="180">
          <template v-slot="{ row }">
            <!-- <el-button type="text" @click="$router.push('/recordManage/detail?id=' + row.id)">详情</el-button> -->
            <el-button type="text" @click="comfirmEnter(row)">确认进场</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import { inventoryType, ygFhState, vehicleTimeType } from '@/utils/dict'

export default {
  name: 'RecordManage',
  data() {
    return {
      vehicleTimeTypeMap: vehicleTimeType,
      inventoryTypeMap: inventoryType,
      ygFhStateMap: ygFhState,
      page: 1,
      total: 0,
      tableData: [],
      loading: false,
      searchForm: {
        vehicleDate: ''
      },
      time: [],
      guanList: []
    }
  },
  created() {
    // this.searchForm.vehicleDate = this.$dayjs().format('YYYY-MM-DD')
    // this.getGuan()
    this.loadData()
  },
  methods: {
    onAdd() {
      this.$router.push('/recordManage/add')
    },
    getGuan() {
      this.$axios.get(this.$apis.oiltabkManage.selectYgInfoByList).then(res => {
        this.guanList = res.list || []
      })
    },
    loadData() {
      this.loading = true
      let startDate = null
      let endDate = null
      if (this.time && this.time.length > 1) {
        startDate = this.time[0]
        endDate = this.time[1]
      }
      this.$axios.get(this.$apis.cyCrkManage.selectYgnInoutRecordByPage, {
        params: {
          page: this.page,
          ...this.searchForm,
          startDate,
          endDate,
          notDate: '1',
          inoutStatus: '1'
        }
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },
    comfirmEnter(row) {
      this.$confirm(`是否确认${row.vehicleKey}进场`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.cyCrkManage.approveYgnInoutRecord, {
          inventoryId: row.inventoryId,
          nodeResult: '1'
        }).then(() => {
          this.loadData()
        })
      })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    resetForm() {
      this.time = []
      this.$refs.searchForm.resetFields()
      this.searchForm = {
        ygId: null,
        ygType: ''
      }
      this.onSearch()
    },
    deleteRow(id) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.recordManage.deleteYgInventory, {
          id
        }).then(() => {
          this.loadData()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'></style>
